import { useCallback } from 'react';

import { useCertifyModal } from '../components/CertifyModal/hooks/useCertifyModal.tsx';
import { useActiveAlertCount } from '../modules/referenceView/AlertsSheet/hooks/useActiveAlertCount.ts';
import { useAppraisifyNavAlertBlock } from './useAppraisifyNavAlertBlock.ts';
import { useAppraisifyNavigation } from './validation/useAppraisifyNavigation.ts';

export const useCertifyButton = () => {
  const activeAlertCount = useActiveAlertCount();
  const { getCertifyErrorText } = useAppraisifyNavigation();
  const { blockCertifyIfNeeded } = useAppraisifyNavAlertBlock();
  const { certifyModal, openCertifyModal } = useCertifyModal();

  const hasBlockingErrorAlerts =
    activeAlertCount.count > 0 && activeAlertCount.severity === 'error';
  const canCertify = !hasBlockingErrorAlerts;
  const certifyErrorText = getCertifyErrorText();

  const handleCertifyClick = useCallback(() => {
    if (blockCertifyIfNeeded()) {
      return;
    }
    openCertifyModal();
  }, [blockCertifyIfNeeded, openCertifyModal]);

  return {
    canCertify,
    certifyErrorText,
    handleCertifyClick,
    certifyModal,
  };
};
